import { initNewStandardCarousel } from './pro-single-family-new-standart/pro-single-family-new-standart';
import { initReviewsCarousel } from './pro-single-family-reviews-carousel/pro-single-family-reviews-carousel';
import YTPlayer from '../../scripts/components/YTPlayer';

window.onReady(() => {
  initNewStandardCarousel();
  initReviewsCarousel();
  YTPlayer.init();
});
